import React from 'react'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { MenuItem } from '@material-ui/core'

export const Suggestions = (suggestion, { query, isHighlighted }) => {
  const matches = match(suggestion.label, query)
  const parts = parse(suggestion.label, matches)

  return (
    <MenuItem selected={isHighlighted} component='div'>
      <div>
        {parts.map((part, index) => {
          return part.highlight
            ? (
              <span key={String(index)} style={{ fontWeight: 700 }}>
                {part.text}
              </span>
            ) 
            : (
              <strong key={String(index)} style={{ fontWeight: 400 }}>
                {part.text}
              </strong>
            )
        })}
      </div>
    </MenuItem>
  )
}


// WEBPACK FOOTER //
// ./src/components/Autocomplete/components/Suggestions/Suggestions.js